import { jwtDecode } from 'jwt-decode'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export enum OperationType {
  SHIPPING = 'SHIPPING',
  CUSTOM = 'CUSTOM'
}

type Operation = {
  id: string
  name: string
  type: OperationType
}

type ProductionSequenceOperation = {
  id: string
  operation: Operation
}

type Activity = {
  id: string
  name: string
}

type TokenPayload = {
  accessKey: string
  productionSequenceOperation: ProductionSequenceOperation
  activity: Activity
  expiresOn: string
  iat: number
  exp: number
  aud: string
  iss: string
  jti: string
}

export const useUserStore = defineStore(
  'user',
  () => {
    const jwtToken = ref<string | null>(null)
    const decodedToken = computed(() =>
      jwtToken.value ? jwtDecode<TokenPayload>(jwtToken.value) : null
    )

    const actions = {
      async logout(input: { redirect: boolean } = { redirect: true }) {
        jwtToken.value = null

        if (input.redirect) {
          const { default: router } = await import('@/router')
          router.push({ name: 'login' })
        }
      },

      setToken(token: string) {
        jwtToken.value = token
      }
    }

    return {
      jwtToken,
      decodedToken,
      actions
    }
  },
  {
    persist: true
  }
)
